import React from 'react';
import { DatePicker, Form } from 'antd';

function PWCDatePicker(formItemInfo) {
  return (
    <Form.Item
      required={formItemInfo.required}
      name={formItemInfo.name}
      label={formItemInfo.label}
      rules={formItemInfo.rules}
      className={formItemInfo.className}
      style={formItemInfo.formItemStyle}
      validateTrigger={['onChange', 'onBlur', 'onFocus', 'onSubmit']}
      onChange={formItemInfo.onChangeForDatePicker}
    >
      <DatePicker
        format="MM/DD/YYYY"
        placeholder="Please select"
        onChange={formItemInfo.onChangeForDatePicker}
        {...formItemInfo.compProps}
      />
    </Form.Item>
  );
}

export default PWCDatePicker;
